<template>
  <div class="submit-request">
    <header class="header">
      <img
        src="../../../assets/logo-text.png"
        alt="OxpeckerLogo"
        class="logo"
      />
    </header>
    <main class="main-content">
      <h1>{{ $t('SubmitRequest.title', { APP_TITLE: APP_TITLE }) }}</h1>
      <div class="main-ms">{{ $t('SubmitRequest.message') }}</div>
      <button
        class="entropool"
        @click="entropool"
      >{{ $t('SubmitRequest.button', { APP_TITLE: APP_TITLE }) }}</button>
    </main>
  </div>
</template>

<script>
export default {
  name: 'SubmitRequest',
  data() {
    return {};
  },
  methods: {
    entropool() {
      this.$router.push({ name: 'MainView' });
    },
  },
};
</script>

<style lang="scss">
.submit-request {
  width: 100%;
  height: calc(100vh - 20px);

  .header {
    display: flex;
    justify-content: left;
    background-color: #ffffff;
    width: 95%;
    border-radius: 5px;
    padding: 10px 40px;
    margin: 0px 10px;
  }

  .main-content {
    margin: 10px auto;
    background: #ffffff;
    width: 95%;
    border-radius: 5px;
    padding: 20px 40px;
    height: calc(100vh - 150px);

    h1 {
      text-align: center;
    }

    .main-ms {
      font-size: 14px;
      display: flex;
      justify-content: center;
      color: #2b2b2b;
      width: 400px;
      margin: 0 auto; /* 居中 */
      text-align: center;
    }

    .entropool {
      background-color: #2b2b2b;
      color: #ffffff;
      width: 200px; /* 固定宽度 */
      height: 40px; /* 固定高度 */
      line-height: 40px;
      border-radius: 5px;
      margin: 50px auto; /* 居中 */
      text-align: center;
      display: block; /* 使按钮块级元素以便居中 */
    }
  }
}
</style>
